
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Button from '../../../components/base/Button';
import JsonViewer from '../../../components/base/JsonViewer';

export default function AirWaybillTemplate() {
  const navigate = useNavigate();

  const airWaybillSchema = {
    "awb_number": "",
    "origin_airport": "",
    "destination_airport": "",
    "shipper_name": "",
    "shipper_address": "",
    "consignee_name": "",
    "consignee_address": "",
    "flight_number": "",
    "flight_date": "",
    "total_weight": "",
    "weight_unit": "",
    "number_of_pieces": "",
    "cargo_description": "",
    "declared_value": "",
    "currency": "",
    "handling_information": "",
    "special_service_request": "",
    "chargeable_weight": "",
    "rate_class": "",
    "commodity_item_number": "",
    "nature_and_quantity": ""
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <Navbar showUserActions={true} />
      
      <div className="px-4 py-6">
        <Button variant="outline" onClick={() => navigate('/templates')} className="mb-6">
          <i className="ri-arrow-left-line mr-2"></i>
          Back to Templates
        </Button>
      </div>
      
      <div className="flex flex-col items-center px-4">
        <div className="w-full max-w-4xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-indigo-100">
              <i className="ri-plane-line text-2xl text-indigo-600"></i>
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Air Waybill Template</h1>
            <p className="text-lg text-gray-600">JSON Schema - View Only</p>
            <div className="w-full h-px bg-gray-300 mt-4"></div>
          </div>
          
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="mb-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">Schema Structure</h2>
              <p className="text-gray-600 text-sm mb-4">
                This template extracts key information from air cargo documents and shipping manifests.
              </p>
            </div>
            
            <JsonViewer data={airWaybillSchema} />
          </div>
        </div>
      </div>
    </div>
  );
}
